import { PageTitle } from '_metronic/layout/core'

// import KumopackStepper from 'Presentation/Components/KumopackStepper'
import SaveButtonGroup from './Components/SaveButtonGroup'
import GenerationInformation from './Components/GeneralInformation'
import Characteristics from './Components/Characteristics'
import ProductOptionalView from '../Form/Components/ProductOptional/View'
import Delivery from './Components/Delivery'
import Additional from './Components/Additional'

import useViewModel from './ViewModel'
import ProductCategorySelect from './Components/ProductCategory'

//////////
// View //
//////////

const ProductFormView = () => {
	const { backMain } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				<div className="col-12">
					{/* <KumopackStepper
						color="primary"
						items={[
							{
								label: '1. ข้อมูลทั่วไป',
								status: 'done',
								description: 'ชื่อสินค้า ภาพ หมวดหมู่',
							},
							{
								label: '2. คุณลักษณะของสินค้า',
								status: 'active',
								description: 'แบรนด์ สี ขนาด ประเภท',
							},
							{
								label: '3. ข้อมูลการขาย',
								status: 'pending',
								description: 'ตัวเลือกผลิตภัณฑ์',
							},
							{
								label: '4. ข้อมูลการจัดส่ง',
								status: 'pending',
								description: 'ไซส์ กล่อง น้ำหนัก',
							},
							{
								label: '5. อืื่นๆ',
								status: 'pending',
								description: 'กลุ่มการแสดงผลสินค้า',
							},
						]}
					/> */}
				</div>

				<div className="col-12">
					<div className="separator border-kumopack-grey-200"></div>
				</div>

				<div className="col-12">
					<SaveButtonGroup cancel={backMain} />
				</div>

				{/* begin:: Form */}
				<div className="col-12 col-xl-9">
					<GenerationInformation />
				</div>
				<div className="col-12 col-xl-3">
					<ProductCategorySelect />
				</div>

				<div className="col-12 col-xl-9">
					<Characteristics />
				</div>

				<div className="col-12 col-xl-9">
					<ProductOptionalView />
				</div>

				<div className="col-12 col-xl-9">
					<Delivery />
				</div>

				<div className="col-12 col-xl-9">
					<Additional />
				</div>
				{/* end:: Form */}

				<div className="col-12 col-xl-9">
					<SaveButtonGroup cancel={backMain} />
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Products',
						path: '/products',
						isActive: false,
						isSeparator: false,
						customIcon: (
							<img
								className="me-2"
								src="/media/kumopack-sidebar-icons/Clipboard.png"
								alt="Breadcrumbs Page Custom Icon"
								width={16}
								height={16}
							/>
						),
					},
					{
						title: 'New Product',
						path: '/products/new',
						isActive: true,
						isSeparator: false,
					},
				]}>
				New Product
			</PageTitle>

			{children}
		</>
	)
}

export default ProductFormView
